import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=1be40798&scoped=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=ts"
export * from "./InputCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=1be40798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be40798",
  null
  
)

export default component.exports